import { createSelector } from 'reselect';

const getLead = state => state.lead;

const LeadSelectors = {
    makeAllLeads: createSelector([getLead], lead => lead.allLeads),
    makeLeadsForListing: createSelector([getLead], lead => lead.leadsForListing),
    makeLead: createSelector([getLead], lead => lead.lead),
};

export default LeadSelectors;
